__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.1", () => (() => (__webpack_require__(28165))), 1);
			register("@icanbwell/ui-toolkit", "2.95.6", () => (() => (__webpack_require__(87596))), 1);
			register("@mui/material", "5.15.15", () => (() => (__webpack_require__(29761))), 1);
			register("@mui/system", "5.15.15", () => (() => (__webpack_require__(71513))), 1);
			register("lodash", "4.17.21-aikido.2", () => (() => (__webpack_require__(76635))), 1);
			register("react-i18next", "11.15.3", () => (() => (__webpack_require__(57619))), 1);
			register("react-redux", "7.2.5", () => (() => (__webpack_require__(7305))), 1);
			register("react-router-dom", "6.23.1", () => (() => (__webpack_require__(79068))), 1);
			register("react-router", "6.23.1", () => (() => (__webpack_require__(92287))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(2784))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};